import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/Main/App';

ReactDOM.render(<App />, document.getElementById('root'));